import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  CircularProgress,
} from "@material-ui/core";

import { ConfirmPopupStyle } from "./style";
import { toast } from "react-toastify";
import { utcToLocal } from "@utils/commonFunctions";
import API from "@services/axios";

function ConfirmPopup(props) {
  const classes = ConfirmPopupStyle();
  const {
    id,
    status,
    endDate,
    startDate,
    cities
  } = props.getInfoUpdate;
  const [loading, setLoading] = useState(false);

  const handleUpdateStatus = async () => {
    setLoading(true);
    try {
      const currentDate = utcToLocal(null, props.dataFuel?.cities?.timezone, "YYYY-MM-DD");
      const expiredAt = endDate ? utcToLocal(endDate, cities?.timezone, "YYYY-MM-DD") : (status === "Scheduled" ? startDate : currentDate);
      await API.put(`customers/fuelSurcharge/${id}`, { endDate: expiredAt });
      props.handleClose();
      if (status === "Scheduled") {
        props.updatedFuelSurchargeRate.current = false;
        if (!props.existingActiveStartDate) {
          props.tempFuelSurchargeRate.current = null;
        }
        props.getFuelSurchargeHistory();
      } else { // Active
        props.getCustomer();
        props.tempFuelSurchargeRate.current = null;
        props.tempErrorFuelSurchargeRate.current = null;
      }
      toast.success("Fuel Surcharge Updated Successfully");
    } catch (err) {
      toast.error(err?.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={classes.DeleteWrapper}>
      <Dialog
        open={props.open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.customModal}
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Updating the end date will also set the record status to "{status === "Active" ? "Expired" : "Cancelled"}".{<br/>}
            Proceed to update?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={props.handleClose}
            color="primary"
            className="primary-btn gray-border-btn"
          >
            Cancel
          </Button>
          <Button
            onClick={handleUpdateStatus}
            color="primary"
            className="orange-btn primary-btn center-loading-indicator"
            disabled={loading}
          >
            {loading ? (
              <CircularProgress color="inherit" />
            ) : (
              "Update"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
export default ConfirmPopup;
